import React, { useState, createContext, useContext } from 'react';
type Language = 'es' | 'en';
interface Translations {
  [key: string]: {
    es: string;
    en: string;
  };
}
const translations: Translations = {
  // Header
  'header.subtitle': {
    es: 'Marketing de Campo | New Jersey, USA',
    en: 'Field Marketing | New Jersey, USA'
  },
  // Hero
  'hero.title': {
    es: '¿Tu negocio en New Jersey necesita más clientes?',
    en: 'Does your business in New Jersey need more clients?'
  },
  'hero.subtitle': {
    es: 'Llevamos tu marca directamente frente a tu cliente ideal — sin anuncios costosos, sin algoritmos, sin esperar resultados que nunca llegan.',
    en: 'We bring your brand directly in front of your ideal client — no expensive ads, no algorithms, no waiting for results that never come.'
  },
  'hero.tagline': {
    es: 'Personas reales. Presencia real. Resultados reales.',
    en: 'Real people. Real presence. Real results.'
  },
  'hero.cta': {
    es: 'QUIERO MÁS CLIENTES — ESCRÍBENOS AHORA',
    en: 'I WANT MORE CLIENTS — CONTACT US NOW'
  },
  'hero.ctaSubtext': {
    es: '(Respuesta garantizada en menos de 30 minutos)',
    en: '(Guaranteed response in less than 30 minutes)'
  },
  // Problem
  'problem.title': {
    es: 'Tienes un gran negocio. El problema es que nadie lo sabe.',
    en: 'You have a great business. The problem is nobody knows about it.'
  },
  'problem.body1': {
    es: 'Eres abogado, médico o dueño de un negocio local en NJ. Trabajas duro todos los días — pero los clientes nuevos no llegan solos.',
    en: "You are a lawyer, doctor, or local business owner in NJ. You work hard every day — but new clients don't come on their own."
  },
  'problem.body2': {
    es: 'Mientras tú esperas, tu competencia los está captando.',
    en: 'While you wait, your competition is capturing them.'
  },
  'problem.pain1': {
    es: 'Anuncios digitales que nadie ve',
    en: 'Digital ads that nobody sees'
  },
  'problem.pain2': {
    es: 'Google Ads que consume tu presupuesto sin resultados reales',
    en: 'Google Ads that consume your budget without real results'
  },
  'problem.pain3': {
    es: 'Boca a boca que no escala',
    en: "Word of mouth that doesn't scale"
  },
  'problem.pain4': {
    es: 'Flyers sin estrategia que terminan en la basura',
    en: 'Flyers without strategy that end up in the trash'
  },
  'problem.closing': {
    es: 'Cada día sin visibilidad activa es un cliente que se va con alguien más.',
    en: 'Every day without active visibility is a client going to someone else.'
  },
  // Solution
  'solution.title': {
    es: 'Presentamos el Sistema de Presencia Local Activa™',
    en: 'Introducing the Active Local Presence System™'
  },
  'solution.subtitle': {
    es: 'La única agencia de marketing de campo en New Jersey que lleva tu marca directamente a tus clientes ideales — cara a cara, en tu zona, todos los días.',
    en: 'The only field marketing agency in New Jersey that brings your brand directly to your ideal clients — face to face, in your area, every day.'
  },
  'solution.scroll': {
    es: 'Scroll to see full table',
    en: 'Scroll to see full table'
  },
  'solution.th1': {
    es: 'Lo que hacemos',
    en: 'What we do'
  },
  'solution.th2': {
    es: 'Resultado',
    en: 'Result'
  },
  'solution.action1': {
    es: 'Identificamos exactamente dónde están tus clientes',
    en: 'We identify exactly where your clients are'
  },
  'solution.result1': {
    es: 'Targeting local preciso',
    en: 'Precise local targeting'
  },
  'solution.action2': {
    es: 'Desplegamos nuestro equipo profesional en tu zona',
    en: 'We deploy our professional team in your area'
  },
  'solution.result2': {
    es: 'Visibilidad inmediata',
    en: 'Immediate visibility'
  },
  'solution.action3': {
    es: 'Generamos conexiones directas y leads calificados',
    en: 'We generate direct connections and qualified leads'
  },
  'solution.result3': {
    es: 'Clientes reales interesados',
    en: 'Real interested clients'
  },
  'solution.action4': {
    es: 'Te entregamos reportes semanales de resultados',
    en: 'We deliver weekly results reports'
  },
  'solution.result4': {
    es: 'Crecimiento constante y medible',
    en: 'Constant and measurable growth'
  },
  // Testimonials
  'testimonials.title': {
    es: 'Negocios como el tuyo ya están creciendo',
    en: 'Businesses like yours are already growing'
  },
  'testimonials.quote1': {
    es: 'En menos de 45 días empecé a recibir consultas de clientes que nunca me hubieran encontrado solos. El retorno fue inmediato.',
    en: 'In less than 45 days I started receiving inquiries from clients who would never have found me on their own. The return was immediate.'
  },
  'testimonials.role1': {
    es: 'Abogado de Inmigración',
    en: 'Immigration Lawyer'
  },
  'testimonials.quote2': {
    es: 'Su equipo representó mi clínica de forma profesional. Los resultados fueron visibles desde la primera semana.',
    en: 'Their team represented my clinic professionally. The results were visible from the first week.'
  },
  'testimonials.role2': {
    es: 'Clínica Médica',
    en: 'Medical Clinic'
  },
  'testimonials.quote3': {
    es: 'Empezamos a ver clientes nuevos reales en menos de 30 días. Totalmente diferente a todo lo que habíamos intentado antes.',
    en: 'We started seeing real new clients in less than 30 days. Totally different from anything we had tried before.'
  },
  'testimonials.role3': {
    es: 'Taller Automotriz',
    en: 'Auto Repair Shop'
  },
  // Who Is It For
  'who.title': {
    es: '¿Tu negocio está en esta lista?',
    en: 'Is your business on this list?'
  },
  'who.th1': {
    es: 'Tipo de Negocio',
    en: 'Business Type'
  },
  'who.th2': {
    es: '¿Trabajamos contigo?',
    en: 'Do we work with you?'
  },
  'who.type1': {
    es: 'Bufetes y Abogados en NJ',
    en: 'Law Firms and Lawyers in NJ'
  },
  'who.type2': {
    es: 'Clínicas y Consultorios Médicos en NJ',
    en: 'Clinics and Medical Offices in NJ'
  },
  'who.type3': {
    es: 'Talleres y Negocios Automotrices en NJ',
    en: 'Auto Repair Shops and Automotive Businesses in NJ'
  },
  'who.type4': {
    es: 'Empresas y Emprendedores Locales en NJ',
    en: 'Local Businesses and Entrepreneurs in NJ'
  },
  'who.yes': {
    es: 'Sí',
    en: 'Yes'
  },
  'who.bottom': {
    es: 'Si tu negocio está en New Jersey y necesitas clientes reales — trabajamos contigo.',
    en: 'If your business is in New Jersey and you need real clients — we work with you.'
  },
  // Plans
  'plans.title': {
    es: 'Elige tu plan y empieza a crecer hoy',
    en: 'Choose your plan and start growing today'
  },
  'plans.name1': {
    es: 'Esencial',
    en: 'Essential'
  },
  'plans.ideal1': {
    es: 'Negocios comenzando su presencia local',
    en: 'Businesses starting their local presence'
  },
  'plans.price1': {
    es: 'Desde $180',
    en: 'From $180'
  },
  'plans.name2': {
    es: 'Estándar',
    en: 'Standard'
  },
  'plans.ideal2': {
    es: 'Negocios que quieren crecimiento constante',
    en: 'Businesses that want constant growth'
  },
  'plans.price2': {
    es: 'Desde $200',
    en: 'From $200'
  },
  'plans.name3': {
    es: 'Premium',
    en: 'Premium'
  },
  'plans.ideal3': {
    es: 'Negocios que quieren dominar su mercado',
    en: 'Businesses that want to dominate their market'
  },
  'plans.price3': {
    es: 'Desde $230',
    en: 'From $230'
  },
  'plans.popular': {
    es: 'Más Popular',
    en: 'Most Popular'
  },
  'plans.bottom': {
    es: '¿No sabes cuál es el ideal para ti? Te lo decimos gratis en 5 minutos.',
    en: "Don't know which one is ideal for you? We'll tell you for free in 5 minutes."
  },
  'plans.cta': {
    es: 'QUIERO SABER QUÉ PLAN ES PARA MÍ — GRATIS',
    en: 'I WANT TO KNOW WHICH PLAN IS FOR ME — FREE'
  },
  // Urgency
  'urgency.badge': {
    es: 'Disponibilidad Limitada por Zona',
    en: 'Limited Availability by Zone'
  },
  'urgency.body1': {
    es: 'Solo trabajamos con',
    en: 'We only work with'
  },
  'urgency.body2': {
    es: 'un negocio por zona geográfica',
    en: 'one business per geographic zone'
  },
  'urgency.body3': {
    es: 'para garantizar resultados exclusivos y no promover a tu competencia directa.',
    en: 'to guarantee exclusive results and not promote your direct competition.'
  },
  'urgency.zones': {
    es: 'Zonas Activas',
    en: 'Active Zones'
  },
  'urgency.warning': {
    es: 'Los cupos se asignan por orden de llegada. Cuando tu zona se llene — tendrás que esperar.',
    en: 'Spots are assigned on a first-come, first-served basis. When your zone fills up — you will have to wait.'
  },
  'urgency.cta': {
    es: 'RESERVAR MI CUPO AHORA — ANTES DE QUE SE LLENE',
    en: 'RESERVE MY SPOT NOW — BEFORE IT FILLS UP'
  },
  'urgency.coverageTitle': {
    es: 'ZONAS DE COBERTURA EN NORTH JERSEY',
    en: 'COVERAGE ZONES IN NORTH JERSEY'
  },
  // FAQ
  'faq.title': {
    es: 'Preguntas Frecuentes',
    en: 'Frequently Asked Questions'
  },
  'faq.q1': {
    es: '¿Cuánto tarda en verse resultados?',
    en: 'How long does it take to see results?'
  },
  'faq.a1': {
    es: 'La mayoría de clientes ven primeros resultados desde la primera semana de campaña activa.',
    en: 'Most clients see first results from the first week of active campaign.'
  },
  'faq.q2': {
    es: '¿Hay contrato largo?',
    en: 'Is there a long contract?'
  },
  'faq.a2': {
    es: 'No. Planes flexibles sin compromisos a largo plazo. Queremos ganarnos tu confianza con resultados.',
    en: 'No. Flexible plans with no long-term commitments. We want to earn your trust with results.'
  },
  'faq.q3': {
    es: '¿La consulta inicial tiene costo?',
    en: 'Does the initial consultation have a cost?'
  },
  'faq.a3': {
    es: 'No. Es completamente gratuita y sin compromiso.',
    en: 'No. It is completely free and without obligation.'
  },
  'faq.q4': {
    es: '¿En qué zonas trabajan?',
    en: 'In which areas do you work?'
  },
  'faq.a4': {
    es: 'Newark, Jersey City, Elizabeth, Paterson, Union City y zonas aledañas.',
    en: 'Newark, Jersey City, Elizabeth, Paterson, Union City and surrounding areas.'
  },
  'faq.q5': {
    es: '¿Funcionará para mi tipo de negocio?',
    en: 'Will it work for my type of business?'
  },
  'faq.a5': {
    es: 'En tu consulta gratuita analizamos tu situación específica y te decimos honestamente cómo podemos ayudarte.',
    en: 'In your free consultation we analyze your specific situation and honestly tell you how we can help you.'
  },
  // Final CTA
  'final.title': {
    es: '¿Listo para dejar de ser invisible en tu zona?',
    en: 'Ready to stop being invisible in your area?'
  },
  'final.subtitle': {
    es: 'Da el primer paso ahora — es gratis y toma menos de 2 minutos.',
    en: "Take the first step now — it's free and takes less than 2 minutes."
  },
  'final.benefit1': {
    es: 'Consulta gratuita personalizada',
    en: 'Personalized free consultation'
  },
  'final.benefit2': {
    es: 'Análisis de tu visibilidad actual en tu zona',
    en: 'Analysis of your current visibility in your area'
  },
  'final.benefit3': {
    es: 'Estrategia recomendada sin costo ni compromiso',
    en: 'Recommended strategy with no cost or obligation'
  },
  'final.cta': {
    es: '👉 QUIERO MÁS CLIENTES — HABLAR AHORA',
    en: '👉 I WANT MORE CLIENTS — TALK NOW'
  },
  'final.subtext': {
    es: '(Respuesta garantizada en menos de 30 minutos)',
    en: '(Guaranteed response in less than 30 minutes)'
  },
  // Footer
  'footer.subtitle': {
    es: 'Marketing de Campo | New Jersey, USA',
    en: 'Field Marketing | New Jersey, USA'
  },
  'footer.privacy': {
    es: 'Política de Privacidad',
    en: 'Privacy Policy'
  },
  'footer.terms': {
    es: 'Términos y Condiciones',
    en: 'Terms and Conditions'
  },
  'footer.copyright': {
    es: '© 2025 K.J Premium Marketing LLC — Todos los derechos reservados',
    en: '© 2025 K.J Premium Marketing LLC — All rights reserved'
  },
  // WhatsApp Float
  'wa.title': {
    es: '¡Cupos limitados!',
    en: 'Limited spots!'
  },
  'wa.text': {
    es: 'Reserva tu zona ahora antes de que se llene.',
    en: 'Reserve your zone now before it fills up.'
  },
  'wa.cta': {
    es: 'Reservar ahora →',
    en: 'Reserve now →'
  }
};
interface LanguageContextType {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (key: string) => string;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export const LanguageProvider: React.FC<{
  children: ReactNode;
}> = ({
  children
}) => {
  const [lang, setLang] = useState<Language>('es');
  const t = (key: string) => {
    if (!translations[key]) {
      console.warn(`Translation key not found: ${key}`);
      return key;
    }
    return translations[key][lang];
  };
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-250">
      {children}
    </LanguageContext.Provider>;
};
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};